import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

const ALWAYS_AVAILABLE = 999999;

const HoldCounts = ({ localeKey = 'holdCount', tagElement = 'span', availability, ...props }) => {
  const localisedStatus = availability.get('localisedStatus');
  const heldCopies = availability.get('heldCopies');
  const totalCopies = availability.get('totalCopies');
  const availableCopies = availability.get('availableCopies');
  const isAvailableNotHoldable =
    localisedStatus === 'AVAILABLE_NOT_HOLDABLE_AT_THIS_TIME' || localisedStatus === 'AVAILABLE_NOT_HOLDABLE' || false;

  if (
    ((isAvailableNotHoldable && heldCopies > 0) || availableCopies === 0) &&
    totalCopies !== ALWAYS_AVAILABLE &&
    totalCopies !== 0
  ) {
    const TagElement = tagElement;
    return (
      <FormattedMessage id={localeKey} values={{ heldCopies: heldCopies.toString(), totalCopies }}>
        {message => (
          <TagElement {...props} className="cp-hold-counts">
            {message}
          </TagElement>
        )}
      </FormattedMessage>
    );
  }
  return null;
};

HoldCounts.propTypes = {
  localeKey: PropTypes.string,
  tagElement: PropTypes.string,
  availability: ImmutablePropTypes.map
};

export default HoldCounts;
